// extracted by mini-css-extract-plugin
export default {"wrapper":"SelfiesTip_style_wrapper__9P3IP","rotate":"SelfiesTip_style_rotate__opy1d"};